import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'

import { tasks as tasksApi } from 'redux/modules/api'
import { permissions } from 'helpers/decorators'

import { ROLES } from 'constants/enums'


function decorator (config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      permissions(),
      connect(
        ({ api, auth }) => ({
          tasks: api.tasks,
          user: auth.user,
          activeOrganization: auth.organization
        }),
        { ...tasksApi.overview }
      )
    )

    class TasksOverview extends Component {
      static propTypes = {
        permissions: PropTypes.object.isRequired,
        tasks: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        activeOrganization: PropTypes.object.isRequired,
        getTasksOverview: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {},
        activeOrganization: {}
      }

      componentDidMount () {
        const { tasks, permissions: appPermission } = this.props

        if (appPermission.activeRole === ROLES.IF_STAFF_USER.u) {
          return null
        }

        // permission is required
        if (config.roles) {
          if (config.roles.some(item => item === appPermission.activeRole)) {
            config.overview && this.handleGetTasksOverview(tasks.overview, {
              activeOrganizationId: this.props.activeOrganization.id,
              awardLeaderId: get(this.props, 'user.personId')
            })
          }
          // permission required but wrong role is logged
          return null
        }

        config.overview && this.handleGetTasksOverview(tasks.overview, {
          activeOrganizationId: this.props.activeOrganization.id,
          awardLeaderId: get(this.props, 'user.personId')
        })
      }

      handleGetTasksOverview = tasks => {
        const { params, activeOrganization } = this.props

        this.props.getTasksOverview(tasks.overview, {
          orgId: config.forOrganisation ? params.id : null,
          activeOrganizationId: activeOrganization.id,
          awardLeaderId: get(this.props, 'user.personId')
        })
      }

      render () {
        return <ComposedComponent {...this.props} />
      }
    }

    return enhance(TasksOverview)
  }
}

export default decorator
